import React, { useEffect, useState } from "react";

export default function PathListItem({ path, isSelected, onSelect, onRename, onDelete }) {
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(path.name || "Untitled path");

  useEffect(() => setName(path.name || "Untitled path"), [path.name]);

  const saveName = async () => {
    const nextName = name.trim();
    if (!nextName) return;
    await onRename(nextName);
    setIsEditing(false);
  };

  const confirmDelete = () => {
    if (window.confirm(`Delete “${path.name || "Untitled path"}”? This cannot be undone.`)) onDelete();
  };

  return (
    <div className={`dc-path-card ${isSelected ? "selected" : ""}`}>
      <button className="dc-path-main" type="button" onClick={onSelect}>
        <span className="dc-path-dot" />
        <span>
          <strong>{path.name || "Untitled path"}</strong>
          <small>{path.points?.length || 0} points</small>
        </span>
      </button>
      {isEditing ? (
        <div className="dc-rename-row">
          <input value={name} autoFocus onChange={(event) => setName(event.target.value)} onKeyDown={(event) => {
            if (event.key === "Enter") saveName();
            if (event.key === "Escape") setIsEditing(false);
          }} />
          <button type="button" onClick={saveName}>Save</button>
        </div>
      ) : (
        <div className="dc-path-actions">
          <button type="button" onClick={() => setIsEditing(true)}>Rename</button>
          <button className="danger" type="button" onClick={confirmDelete}>Delete</button>
        </div>
      )}
    </div>
  );
}

